var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadBigIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".upload-big-icon-a,.upload-big-icon-b{fill:#acb5c0;stroke:#acb5c0;}.upload-big-icon-a{opacity:0;}.upload-big-icon-b{stroke-width:0.5px;}.upload-big-icon-c{stroke:none;}.upload-big-icon-d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "upload-big-icon-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "upload-big-icon-c",
    width: 43,
    height: 43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "upload-big-icon-d",
    x: 0.5,
    y: 0.5,
    width: 42,
    height: 42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.299 4.474)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "upload-big-icon-b",
    d: "M49.978,319.4a.545.545,0,0,0-.545.545v9.851H21.093v-9.851a.545.545,0,0,0-1.09,0v10.4a.545.545,0,0,0,.545.545h29.43a.545.545,0,0,0,.545-.545v-10.4A.545.545,0,0,0,49.978,319.4Z",
    transform: "translate(-20.003 -297.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "upload-big-icon-b",
    d: "M132.812,8.029l.013-.013,6.156-6.155V27.25a.545.545,0,0,0,1.09,0V1.861l6.155,6.155A.545.545,0,0,0,147,7.245L139.912.16a.545.545,0,0,0-.771,0h0l-7.085,7.085a.545.545,0,1,0,.757.784Z",
    transform: "translate(-124.266 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBigIcon);
export default __webpack_public_path__ + "static/media/upload-big-icon.e889eabeacc020a05a3c68ca5467fc3a.svg";
export { ForwardRef as ReactComponent };